import { useState, useContext, useEffect } from "react";
import { Dialog } from "@material-ui/core"
import styles from './PayrollModals.module.css'
import { clearPayrollProcess } from "../../../context/PayrollProcess/Actions";
import PayrollProcessContext from "../../../context/PayrollProcess/PayrollProcessContext";
import { useMutation } from "@apollo/client";
import { CREACION_TOKEN_DISPERSION, GET_EVENTUALPAYROLL, SEND_DISPERSION_EVENTUAL } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { v4 as uuidv4 } from 'uuid'
import { WarningAlert } from "../../../alerts/WarningAlert";
import useGeolocation from "../../../hooks/useGeolocation";
import { ErrorAlert } from "../../../alerts/errorAlert";

const AceptarDispersarEventual = (props: any) => {
  const { totalesDispersar, totales, seleccionados, idRegistro } = props
  const { state, dispatch } = useContext(PayrollProcessContext)
  const [activo, setactivo] = useState(false)
  const [mensaje, setMensaje] = useState('Uno')
  const [permision, setPermision] = useState(false)
  const [sendDispersion] = useMutation(SEND_DISPERSION_EVENTUAL, {
    refetchQueries: [
      { query: GET_EVENTUALPAYROLL, variables: { getPayrollDispersionId: idRegistro } }
    ]
  })
  const [creacionToken] = useMutation(CREACION_TOKEN_DISPERSION, {
  })

  useEffect(() => {
    handleCheckPermision()
  }, [])


  const { location, error } = useGeolocation()

  const handleClose = () => {
    clearPayrollProcess({}, dispatch)
  }

  const handleCheckPermision = () => {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state === 'granted') {
        setPermision(true)
      } else if (result.state === 'prompt') {
        // Solicita el permiso de geolocalización al usuario
        navigator.geolocation.getCurrentPosition(
          () => setPermision(true),
          () => setPermision(false)
        );
        console.log('Permiso de geolocalización solicitado')
      } else if (result.state === 'denied') {
        setPermision(false)
      }
    })
  }

  const handleChange = (e: any) => {
    if (e.target.value === 'CONFIRMAR') {
      setactivo(true)
    } else {
      setactivo(false)
    }
  }

  const agregaSeleccionados = async () => {
    if (permision) {
      if (location) {
        const tokenCreado = uuidv4();
        await creacionToken({
          variables: {
            input: {
              Desde: "Eventual",
              idRegistro: parseInt(idRegistro),
              token: tokenCreado,
              numeroRegistros: parseInt(totalesDispersar)
            }
          }
        })
        setMensaje((current) => current = 'Dos')

        props.setProcesoDispersion(true)
        let Array: any = []
        seleccionados.forEach((lis: any) => {
          Array.push({ id: parseInt(lis) })
        })
        await sendDispersion({
          variables: {
            sendDispersionEventualId: Array,
            lattitude: location?.latitude,
            longitude: location?.longitude,
          }
        })
        props.reinicia()
        props.setProcesoDispersion(false)

        setactivo(false)
        SuccessfulAlert({ text: "Registro Dispersado" })
        setMensaje((current) => current = 'Uno')
        props.updateDataAfterDispersar();
        handleClose()
      } else if (error) {
        ErrorAlert({ text: "Error al obtener la localizacion" });
        setactivo(false)
        handleClose()
        return;
      }
    } else {
      WarningAlert({ text: "Por favor, activa los permisos de geolocalización para dispersar." })
      setactivo(false)
      handleClose()
    }
  }

  return (
    <Dialog aria-labelledby='costumized-dialog-title' open={state.aceptarDispersarEventual} fullWidth={false} maxWidth={"md"}>
      <div className={styles.contenedorPrincipal}>
        <div className={styles.contenedorCerrarModal}>
          {mensaje === 'Tres' ?
            null
            :
            <div
              className={styles.cerrarModal}
              onClick={() => handleClose()}
            >
            </div>
          }

        </div>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.fim_iconoPrincipal}>
            <div className={styles.fim_iconoComplemento}>
            </div>
          </div>
        </div>
        <div className={styles.tituloAtencion}>
          ¡Atenci&oacute;n!
        </div>
        {mensaje === 'Uno' ?
          <>
            <div className={styles.em_mensajePrtincipal}>
              Est&aacute;s por dispersar n&oacute;mina a {totalesDispersar}/{totales} colaboradores
            </div>
            <div className={styles.em_mensajePrtincipal}>
              Escribe CONFIRMAR para continuar
            </div>
            <div>
              <input
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
            </div>
          </>
          : null
        }
        {mensaje === 'Dos' ?
          <>
            <div className={styles.em_mensajePrtincipal}>
              Dispersi&oacute;n en proceso, no actualices ni cierres la pantalla
            </div>
            <div className={styles.em_mensajePrtincipal}>
              hasta que el proceso haya terminado.
            </div>
            <div className={styles.contenedorLoadingDispersion}>
              <div className={styles.loading}></div>
            </div>
          </>
          : null
        }
        <div className={styles.em_contenedorBotones}>
          {mensaje === 'Dos' ?
            null
            :
            <button
              className={styles.em_botonCancelar}
              onClick={() => handleClose()}
            >
              Cancelar
            </button>
          }
          {mensaje === 'Uno' ?
            (activo === true ?
              <button
                className={`${styles.botonesAtencion} ${styles.continuarAtencion}`}
                onClick={() => agregaSeleccionados()}
              >
                <div>
                  Confirmar
                </div>
              </button>
              :
              <button
                className={`${styles.botonesAtencion} ${styles.continuarAtencionInactivo}`}
              >
                <div>
                  Confirmar
                </div>
              </button>
            )
            : null
          }
        </div>
      </div>
    </Dialog>
  )
}

export default AceptarDispersarEventual